import {useCallback} from 'react'

import {useTableDeselectAllRows} from '../../hooks/tanstack-table/hooks/use-table-row-selection'
import {useTableCellBulkSelectionActions} from './table-cell-bulk-selection'

/**
 * Deselect all rows and cells.
 */
export const useDeselectAll = () => {
  const bulkSelectActions = useTableCellBulkSelectionActions()
  const deselectAllRows = useTableDeselectAllRows()

  return useCallback(
    (clearBulkSelection = true) => {
      if (clearBulkSelection) {
        bulkSelectActions?.clearSelection()
      }
      deselectAllRows()
    },
    [bulkSelectActions, deselectAllRows],
  )
}
